var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6.11458C17.3399 6.11458 17.1814 6.14611 17.0335 6.20737C16.8857 6.26863 16.7513 6.35842 16.6381 6.47161L7.76328 15.3464L7.11683 17.7167L9.48713 17.0703L18.3619 8.19546C18.4751 8.08227 18.5649 7.9479 18.6262 7.80001C18.6874 7.65212 18.719 7.49361 18.719 7.33353C18.719 7.17346 18.6874 7.01495 18.6262 6.86706C18.5649 6.71917 18.4751 6.5848 18.3619 6.47161C18.2488 6.35842 18.1144 6.26863 17.9665 6.20737C17.8186 6.14611 17.6601 6.11458 17.5 6.11458ZM16.5233 4.97553C16.833 4.84727 17.1648 4.78125 17.5 4.78125C17.8352 4.78125 18.1671 4.84727 18.4767 4.97553C18.7864 5.1038 19.0678 5.2918 19.3048 5.5288C19.5418 5.7658 19.7298 6.04716 19.858 6.35682C19.9863 6.66648 20.0523 6.99837 20.0523 7.33353C20.0523 7.6687 19.9863 8.00059 19.858 8.31025C19.7298 8.61991 19.5418 8.90127 19.3048 9.13827L10.3048 18.1383C10.2227 18.2203 10.1207 18.2795 10.0088 18.31L6.34209 19.31C6.11129 19.373 5.86444 19.3074 5.69528 19.1383C5.52611 18.9691 5.46056 18.7223 5.52351 18.4915L6.52351 14.8248C6.55403 14.7129 6.61324 14.6108 6.69528 14.5288L15.6953 5.5288C15.9323 5.2918 16.2136 5.1038 16.5233 4.97553Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a940454f29f16ac69406a47736f073e6.svg";
export { ForwardRef as ReactComponent };